import { LOW_CREDIT_THRESHOLD } from "./constants";

export const getUsedPercentage = (used: number, total: number) => {
  if (total <= 0) return 0;
  return Math.round((used / total) * 100);
};

export const getProgressFillColor = (available: number, total: number) => {
  if (available <= total * LOW_CREDIT_THRESHOLD) return "bg-amber-300";
  return "bg-white";
};
